import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledImg = styled("img")({
  height: "2.125rem",
  maxWidth: "10rem"
});

export const StyledImgBox = styled(Box, {
  shouldForwardProp: prop => prop !== "$isFreya"
})<{ $isFreya?: boolean }>(({ $isFreya }) => ({
  "@media (max-width: 600px)": {
    display: $isFreya ? "block" : "none"
  }
}));

export const StyledBox = styled(Box)`
  width: 12.875rem;

  @media (max-width: 600px) {
    width: 8rem;
  }
`;
